const initTimeLine = () => {
	const section = document.querySelector("section.timeline");

	if (!section) {
		return;
	}

	const projectsYears = document.querySelectorAll(".year");
	const projectsYearsNodes = document.querySelectorAll(".timeline div");

	projectsYears.forEach((projectYear) => {
		projectYear.addEventListener("click", () => {
			projectsYearsNodes.forEach((projectsYearsNode) =>
				projectsYearsNode.classList.remove("active")
			);
			projectYear.parentNode.classList.add("active");
		});
	});
};

export { initTimeLine };
